import type { KeyboardEvent } from "react";

function moveFocus(event: KeyboardEvent<HTMLButtonElement>, key: "ArrowDown" | "ArrowUp") {
  const list = event.currentTarget.closest("[data-faq-list]");
  if (!list) return;
  const buttons = Array.from(list.querySelectorAll<HTMLButtonElement>("[data-faq-trigger]"));
  const index = buttons.indexOf(event.currentTarget);
  const next = key === "ArrowDown" ? index + 1 : index - 1;
  if (next < 0 || next >= buttons.length) return;
  event.preventDefault();
  buttons[next]?.focus();
}

export function FaqItem({
  id,
  index,
  question,
  answer,
  open,
  onToggle,
}: {
  id: number;
  index: number;
  question: string;
  answer: string;
  open: boolean;
  onToggle: () => void;
}) {
  const buttonId = `faq-trigger-${id}`;
  const panelId = `faq-panel-${id}`;
  const number = String(index).padStart(2, "0");

  return (
    <div
      className={
        open
          ? "faq-item rounded-home-20 border-[1.5px] border-home-navy bg-home-cream-2 shadow-home-hard-md"
          : "faq-item rounded-home-20 border-[1.5px] border-home-line bg-home-cream shadow-none"
      }
    >
      <h3 className="m-0 font-normal">
        <button
          id={buttonId}
          type="button"
          data-faq-trigger
          aria-expanded={open}
          aria-controls={panelId}
          onClick={onToggle}
          onKeyDown={(event) => {
            if (event.key === "ArrowDown" || event.key === "ArrowUp") {
              moveFocus(event, event.key);
            }
          }}
          className="flex min-h-[84px] w-full items-center gap-[18px] px-6 py-5 text-left max-sm:px-[18px] max-sm:py-4"
        >
          <span className="w-7 shrink-0 text-[16px] font-bold tabular-nums text-home-accent-text">
            {number}
          </span>
          <span className="flex-1 text-[clamp(18px,1.7vw,22px)] font-semibold leading-[1.3] text-home-navy">
            {question}
          </span>
          <span
            className="faq-plus relative flex h-10 w-10 shrink-0 items-center justify-center rounded-full border-[1.5px] border-home-navy"
            data-open={open}
            aria-hidden="true"
          >
            <span className="faq-plus-bar faq-plus-bar-h" />
            <span className="faq-plus-bar faq-plus-bar-v" />
          </span>
        </button>
      </h3>
      <section
        id={panelId}
        aria-labelledby={buttonId}
        data-open={open}
        aria-hidden={open ? undefined : true}
        className="faq-panel"
      >
        <div className="faq-panel-inner">
          <p className="max-w-[680px] pb-6 pl-[58px] pr-6 text-[18px] leading-[1.6] text-home-body max-sm:pl-[18px]">
            {answer}
          </p>
        </div>
      </section>
    </div>
  );
}
